module.exports = __webpack_public_path__ + "img/banner.be7dae45.jpg";